<template>
  <div class="cust-container">
    <menuBar></menuBar>
    <div>
      <div class="banner">
        <img src="@/assets/images/stem/banner.jpg" />
      </div>

      <div class="content" v-if="$i18n.locale === 'en'">
        <div class="title">Study STEM at SCAD</div>
        <div class="desc">
          <ul>
            <li>
              Explore
              <b
                >32 STEM designated undergraduate and graduate degree
                programs</b
              >
              across animation, architecture, user experience design, visual
              effects, and more, combining creative thinking with advanced
              technology.
            </li>
            <li>
              Gain real-world experience through internships, industry
              certifications, and <b>SCADpro</b> projects with leading global
              organizations including <b>Google, BMW, Lenovo</b>, and
              <b>Roblox</b>.
            </li>
            <li>
              Eligible F-1 international students who complete a qualifying SCAD
              STEM-designated degree may apply for a
              <b>24-month STEM OPT extension</b>. Career preparation continues
              beyond the classroom: according to a 2026 survey,
              <b
                >99% of recent SCAD graduates were employed, pursuing further
                education, or both within 12 months of graduation</b
              >.
            </li>
          </ul>
        </div>
        <div class="line" style=""></div>

        <div>
          <video
            style="width: 100%"
            src="https://scad-minisite.oss-cn-beijing.aliyuncs.com/video/20260929/2026-27_STEM-at-SCAD-Impact_SCN_Burned-GFX_Approved_260925.mp4"
            controls
            poster="https://scad-minisite.oss-cn-beijing.aliyuncs.com/video/20260929/2026-27_STEM-at-SCAD-Impact_SCN_Burned-GFX_Approved_260925.mp4?x-oss-process=video/snapshot,t_4000"
          ></video>
        </div>

        <!--        <div class="title-list">-->
        <!--          <div class="title-row">-->
        <!--            <div>Advertising</div>-->
        <!--            <div>Architecture</div>-->
        <!--            <div>Design for sustainability</div>-->
        <!--            <div>Furniture design</div>-->
        <!--          </div>-->
        <!--          <div class="title-row">-->
        <!--            <div>Animation</div>-->
        <!--            <div>Creative business leadership</div>-->
        <!--            <div>Design management</div>-->
        <!--          </div>-->
        <!--          <div class="title-row">-->
        <!--            <div>Graphic design</div>-->
        <!--            <div>Industrial design</div>-->
        <!--            <div>Luxury and brand management</div>-->
        <!--          </div>-->
        <!--          <div class="title-row">-->
        <!--            <div>Immersive reality</div>-->
        <!--            <div>Interactive design and game development</div>-->
        <!--          </div>-->
        <!--          <div class="title-row">-->
        <!--            <div>Service design</div>-->
        <!--            <div>User experience (UX) design</div>-->
        <!--            <div>Visual effects</div>-->
        <!--          </div>-->
        <!--          <div class="title-row">-->
        <!--            <div>Service design</div>-->
        <!--            <div>User experience (UX) design</div>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>

      <div class="content" v-if="$i18n.locale === 'zh'">
        <div class="title">在 SCAD 学习 STEM</div>
        <div class="desc">
          <ul>
            <li>
              探索
              <b>32 个 STEM 指定的本科及研究生学位项目</b
              >，涵盖动画、建筑、用户体验设计、视觉特效等多个领域，将创意思维与前沿科技相结合。
            </li>
            <li>
              通过实习、专业认证以及
              <b>SCADpro</b> 真实企业项目积累行业实践经验，并有机会参与与
              <b>Google、BMW 宝马、Lenovo 联想、Roblox</b>
              等全球知名企业的合作项目。
            </li>
            <li>
              符合条件的 F-1 国际学生完成符合要求的 SCAD STEM 学位后，可申请
              <b>24 个月的 STEM OPT 延期</b>。职业发展支持也贯穿 SCAD
              教育全过程：2026 年调查显示，<b
                >99% 的 SCAD 应届毕业生在毕业后 12
                个月内实现就业、继续深造，或二者兼有</b
              >。
            </li>
          </ul>
        </div>
        <div class="line" style=""></div>

        <div>
          <video
            style="width: 100%"
            src="https://scad-minisite.oss-cn-beijing.aliyuncs.com/video/20260929/2026-27_STEM-at-SCAD-Impact_SCN_Burned-GFX_Approved_260925.mp4"
            controls
            poster="https://scad-minisite.oss-cn-beijing.aliyuncs.com/video/20260929/2026-27_STEM-at-SCAD-Impact_SCN_Burned-GFX_Approved_260925.mp4?x-oss-process=video/snapshot,t_4000"
          ></video>
        </div>
        <!--        <div class="title-list">-->
        <!--          <div class="title-row">-->
        <!--            <div>广告</div>-->
        <!--            <div>建筑学</div>-->
        <!--            <div>可持续性设计</div>-->
        <!--            <div>家具设计</div>-->
        <!--          </div>-->
        <!--          <div class="title-row">-->
        <!--            <div>动画</div>-->
        <!--            <div>创意商业领导力</div>-->
        <!--            <div>设计管理</div>-->
        <!--          </div>-->
        <!--          <div class="title-row">-->
        <!--            <div>平面设计</div>-->
        <!--            <div>工业设计</div>-->
        <!--            <div>奢侈品与品牌管理</div>-->
        <!--          </div>-->
        <!--          <div class="title-row">-->
        <!--            <div>沉浸式现实</div>-->
        <!--            <div>互动设计与游戏开发</div>-->
        <!--          </div>-->
        <!--          <div class="title-row">-->
        <!--            <div>视觉效果</div>-->
        <!--            <div>服务设计</div>-->
        <!--            <div>用户体验（UX设计）</div>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>

    <goTop></goTop>
    <custFooter></custFooter>
  </div>
</template>

<script>
import menuBar from "../../components/menuBar/index.vue";
import custFooter from "@/components/footer/Footer";
export default {
  metaInfo: {
    title: "SCAD", // set a title
  },
  name: "WhyChooseSCAD",
  components: {
    menuBar,
    custFooter,
  },
  data: function () {
    return {
      showVideo: false,
    };
  },
};
</script>

<style lang="less" scoped>
@import url(Stem.less);
</style>
